import { NavLink } from "react-router-dom";
import joshLogo from "../assets/images/josh-logo.png";

const STORE_URL = "https://joshbrett.store/";

const Header = () => (
  <header className="site-header">
    <NavLink to="/" className="site-logo" aria-label="Josh Brett home">
      <img src={joshLogo} alt="" />
    </NavLink>
    <nav className="site-nav">
      <NavLink to="/" end>
        Home
      </NavLink>
      <NavLink to="/videos">Videos</NavLink>
      <a className="site-nav-store" href={STORE_URL} target="_blank" rel="noreferrer">
        Store
      </a>
    </nav>
  </header>
);

export default Header;
